/* 2026-10-19 sc-depth: Horseman parallax. Layers move at different speeds as the section scrolls past.
   Uses the CSS `translate` property through --py, so it stacks with the existing gallop/moon/ride-in animations. */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // px of travel across one full pass (section entering bottom to leaving top). Negative = far layer.
  var LAYERS = [
    ['.hh-sky__moon', -110],
    ['.hh-sky__fog', -60],
    ['.hh-sky__fog--2', -35],
    ['.hh-drop__bolt', -80],
    ['.hh-drop__copy', 30],
    ['.hh-drop__rider', 55],
    ['.hh-drop__jack', 95]
  ];

  function init() {
    var sec = document.querySelector('.hh-drop');
    if (!sec) return;
    sec.classList.add('hh-depth');
    var items = [];
    LAYERS.forEach(function (l) {
      sec.querySelectorAll(l[0]).forEach(function (el) { items.push([el, l[1]]); });
    });
    if (!items.length) return;

    var visible = false, ticking = false;
    function update() {
      ticking = false;
      var r = sec.getBoundingClientRect(), vh = window.innerHeight;
      // p runs from 1 (section just below the fold) to -1 (just above the top)
      var p = ((r.top + r.height / 2) - vh / 2) / ((vh + r.height) / 2);
      if (p > 1) p = 1; else if (p < -1) p = -1;
      var mobile = window.innerWidth < 750 ? 0.55 : 1;
      for (var i = 0; i < items.length; i++) {
        items[i][0].style.setProperty('--py', (p * items[i][1] * mobile).toFixed(1) + 'px');
      }
    }
    function req() { if (visible && !ticking) { ticking = true; requestAnimationFrame(update); } }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; req(); }, { rootMargin: '200px 0px' }).observe(sec);
    } else { visible = true; }
    document.addEventListener('scroll', req, { passive: true, capture: true });  // the desktop page scrolls inside an element, not the window
    window.addEventListener('resize', req);
    visible = true; update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* sc-scrolled: header goes from clear to solid once the page moves */
(function () {
  var r = document.documentElement, on = null;
  function f() { var se = document.querySelector('[data-sc-scroller]'), s = (window.scrollY || 0) > 4 || (document.querySelector('main') && document.querySelector('main').getBoundingClientRect().top < -4); if (s !== on) { on = s; r.classList.toggle('sc-scrolled', s); } }
  f(); document.addEventListener('scroll', f, { passive: true, capture: true });
})();

/* see-through nav: paint the strip behind the bar in the first panel's color, and flip the nav
   to ink over light panels, paper over dark ones */
(function () {
  var root = document.documentElement;
  function rgba(c) { var m = c && c.match(/[\d.]+/g); return m ? [+m[0], +m[1], +m[2], m[3] == null ? 1 : +m[3]] : null; }
  function lum(c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }
  function bgAt(x, y, hdr) {
    var els = document.elementsFromPoint(x, y);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (hdr && hdr.contains(el)) continue;
      if (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'CANVAS' || el.tagName === 'svg') continue; // judge art by the panel it sits on
      var c = rgba(getComputedStyle(el).backgroundColor);
      if (c && c[3] > 0.5) return c;
    }
    return null;
  }
  function init() {
    var hdr = document.querySelector('.shopify-section-group-header-group header') || document.querySelector('header-component');
    var main = document.querySelector('main');
    if (!hdr || !main) return;
    // strip behind the bar = first panel's color
    var first = null, kids = main.querySelectorAll(':scope > .shopify-section');
    for (var i = 0; i < kids.length && !first; i++) {
      if (kids[i].offsetHeight < 2) continue;
      var w = kids[i].querySelectorAll('*');
      for (var k = 0; k < w.length && k < 6; k++) { var c = rgba(getComputedStyle(w[k]).backgroundColor); if (c && c[3] > 0.5) { first = c; break; } }
      if (!first) { var c2 = rgba(getComputedStyle(kids[i]).backgroundColor); if (c2 && c2[3] > 0.5) first = c2; }
    }
    if (first) document.body.style.backgroundColor = 'rgb(' + first[0] + ',' + first[1] + ',' + first[2] + ')';
    var items = [].slice.call(hdr.querySelectorAll('.header-logo, a.menu-list__link, .header-actions__action, summary.header__icon--menu, cart-icon, .header-actions a'));
    items = items.filter(function (el, i) { return items.indexOf(el) === i && !items.some(function (o) { return o !== el && o.contains(el); }); });
    items.forEach(function (el) { el.classList.add('sc-navi'); });
    var ticking = false;
    function check() {
      ticking = false;
      for (var i = 0; i < items.length; i++) {
        var el = items[i], r = el.getBoundingClientRect();
        if (!r.width) continue;
        var c = bgAt(r.left + r.width / 2, r.top + r.height / 2, hdr) || bgAt(r.left + 2, r.top + r.height / 2, hdr);
        var on = c && lum(c) > 0.55 ? 'light' : 'dark';
        if (el.getAttribute('data-sc-on') !== on) el.setAttribute('data-sc-on', on);
      }
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    document.addEventListener('scroll', req, { passive: true, capture: true });  // the desktop page scrolls inside an element, not the window
    window.addEventListener('resize', req);
    check(); setTimeout(check, 600); setTimeout(check, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
